import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  DEFAULT_CITY_ID: 440300,
  DEFAULT_CITY_NAME: '深圳',
  // DEFAULT_CITY_ID: 440100,
  // DEFAULT_CITY_NAME: '广州',
  CITY_FIRST_CHECK_HAS_FINISH: 1, // 已确认定位city与cookie city

  CITY_FROM_PAGE_TYPE_IS_ZONE: 1, // 从蛋糕卡专区首页进入
  CITY_FROM_PAGE_TYPE_IS_ADDRESS: 2, // 从选择定位地址进入
}, km({
  CITY_CHANGE_SELECTED: null,
  CITY_GET_LIST_SUCCESS: null,
  CITY_GET_LIST_ERROR: null,

  CITY_GET_LOCATE_SUCCESS: null,
  CITY_GET_LOCATE_ERROR: null,
  CITY_SET_GPS_POSITION: null,

  MOVIE_LOCAL_CITY: null,
  // amap 逆地理编码
  CITY_GET_LOCATE_ADDRESS_SUCCESS: null,
  CITY_GET_LOCATE_ADDRESS_ERROR: null,
  CITY_CHANGE_SHIPPING_ADDRESS: null, // 修改收货地址

  CITY_CHANGE_SHIPPING_CITY: null, //修改城市


  CAKESTORECITY_GET_LIST_SUCCESS: null,
  CAKESTORECITY_GET_LIST_ERROR: null,
  CAKESTORE_GET_LIST_SUCCESS: null,
  CAKESTORE_GET_LIST_ERROR: null,

  CITY_SET_CITY_CENTER_LOCATION: null, //城市中心点经纬度

}))
